module.exports = __webpack_public_path__ + "assets/img/nsdk.feb9d498.png";